import NavigableValidation from "./navigableValidation";
import PaymentLineItem from "../../../formability/form_builder/models/paymentLineItems/paymentLineItem";
import PaymentLineItemValidator from "../navigableValidators/paymentLineItemValidator";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";


export default class PaymentLineItemValidation extends NavigableValidation<PaymentLineItem> {
    model: PaymentLineItem;
    validators = [
        new PaymentLineItemValidator({
          section: ValidationModalSection.Workflow
        })
    ];
}